var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box, theme, CloseOutlinedIcon, ThemeProvider, } from '@kareo/design-system';
import ImgTerminal from 'shared-assets/assets/img/terminal-new.svg';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import { IconButton } from '@material-ui/core';
import styled from 'styled-components';
var PLG_SCREEN_SHOW_KEY = 'plg-screen-close';
var SIGN_UP_URL = '/v2/#/payments-onboarding/application';
var LEARN_MORE_URL = '/v2/#/payments-onboarding';
var TOP_OF_FUNNEL_SOURCE = 'Collect Payment Screen';
var CloseAdButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 4px;\n  right: 4px;\n"], ["\n  position: absolute;\n  top: 4px;\n  right: 4px;\n"])));
var PlgScreenAdView = function () {
    var _a = React.useState(false), closePlgScreenPanel = _a[0], setClosePlgScreenPanel = _a[1];
    var handleAdClick = function (url) {
        sessionStorage.setItem('tebraPaymentsTopOfFunnel', TOP_OF_FUNNEL_SOURCE);
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    var handleAdClose = function () {
        setClosePlgScreenPanel(true);
        localStorage.setItem(PLG_SCREEN_SHOW_KEY, JSON.stringify({ plgScreenPanel: true }));
    };
    var dsTheme = getDesignSystemTheme();
    var getIsAdVisible = React.useMemo(function () {
        if (closePlgScreenPanel) {
            return false;
        }
        var adsStorage = localStorage.getItem(PLG_SCREEN_SHOW_KEY);
        if (!!adsStorage) {
            var adsStorageParsed = JSON.parse(adsStorage);
            if (adsStorageParsed.plgScreenPanel) {
                return false;
            }
        }
        return true;
    }, [closePlgScreenPanel]);
    return (React.createElement(React.Fragment, null, getIsAdVisible && (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(Card, null,
            React.createElement(CardMedia, { component: "img", image: ImgTerminal }),
            React.createElement(CloseAdButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleAdClose },
                React.createElement(CloseOutlinedIcon, { fontSize: "inherit" })),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h4", align: "center", style: {
                        lineHeight: '20px',
                        margin: '0 0 13px 0',
                        color: theme.palette.primary.main,
                    } },
                    "Automate your patient billing with ",
                    React.createElement("br", null),
                    " Tebra Payments."),
                React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", alignItems: "center" },
                    React.createElement(Button, { color: "default", "data-testid": "collect-payment-tebra-payments-sign-up", onClick: function () { return handleAdClick(SIGN_UP_URL); }, style: {
                            alignItems: 'center',
                            backgroundColor: 'transparent',
                            border: "1px solid " + theme.palette.primary.main,
                            borderRadius: 24,
                            color: theme.palette.primary.main,
                            cursor: 'pointer',
                            display: 'flex',
                            fontSize: 14,
                            justifyContent: 'center',
                            lineHeight: '20px',
                            marginBottom: 10,
                            minHeight: 28,
                            padding: '3px 24px',
                            textTransform: 'none',
                            width: '74%',
                        } },
                        "Sign Up",
                        React.createElement("i", { "aria-hidden": "true", className: "ki popout", style: { fontSize: 14, marginLeft: 8 } })),
                    React.createElement(Button, { color: "default", "data-testid": "collect-payment-tebra-payments-learn-more", onClick: function () { return handleAdClick(LEARN_MORE_URL); }, variant: "text", style: {
                            alignItems: 'center',
                            color: theme.palette.primary.main,
                            display: 'flex',
                            fontSize: 14,
                            justifyContent: 'center',
                            lineHeight: '20px',
                            minHeight: 24,
                            padding: 0,
                            textTransform: 'none',
                        } },
                        "Learn More",
                        React.createElement("i", { "aria-hidden": "true", className: "ki popout", style: { fontSize: 14, marginLeft: 8 } })))))))));
};
export default PlgScreenAdView;
var templateObject_1;
